import { AppSuccess } from '../../models/AppSuccess';
import { User_Base } from '../../models/User';
import { AC_Description } from './AC_Type';

// Access control configuration
export enum AC_TLGeo_Role {
  TLGEO_ADMIN = 'TLGEO_ADMIN',
}

export enum AC_TLGeo_Permission {
  MANAGE_TLGEO = 'MANAGE_TLGEO',
}

export const AC_TLGeo_RolePermission = {
  TLGEO_ADMIN: ['MANAGE_TLGEO'],
};

// API types
export type AC_TLGeo_Base = {
  user?: User_Base;
  role: AC_TLGeo_Role;
};
export type AC_TLGeo_getMyRoles_Response = Array<AC_TLGeo_Role>;
export type AC_TLGeo_getMyPermissions_Response = Array<AC_TLGeo_Permission>;

export type AC_TLGeo_addRoleForUser_Request = {
  userId: number;
  role: AC_TLGeo_Role;
};
export type AC_TLGeo_addRoleForUser_Response = AppSuccess<AC_TLGeo_Base>;

export type AC_TLGeo_deleteRoleForUser_Request_Query = {
  userId: number;
  role: AC_TLGeo_Role;
};
export type AC_TLGeo_deleteRoleForUser_Response = AppSuccess<AC_TLGeo_Base>;

// Utils
const getRoleDescription = (role: AC_TLGeo_Role): AC_Description => {
  switch (role) {
    case AC_TLGeo_Role.TLGEO_ADMIN:
      return { en: 'super admin account', vi: 'có toàn quyền trên toàn hệ thống' };

    default:
      return { en: 'unknown role', vi: 'role không đúng' };
  }
};

const getPermissionDescription = (permission: AC_TLGeo_Permission): AC_Description => {
  switch (permission) {
    case AC_TLGeo_Permission.MANAGE_TLGEO:
      return { en: 'super admin account', vi: 'có toàn quyền trên toàn hệ thống' };
    default:
      return { en: 'unknown role', vi: 'role không đúng' };
  }
};
const getPermissions = (roles: Array<AC_TLGeo_Role>): Array<AC_TLGeo_Permission> => {
  let permissionsSet = new Set<AC_TLGeo_Permission>();

  for (let i = 0; i < roles.length; i++) {
    let role = roles[i];
    let permissions = AC_TLGeo_RolePermission[role];
    permissions.forEach((permission) => {
      permissionsSet.add(permission as AC_TLGeo_Permission);
    });
  }

  return Array.from(permissionsSet);
};

export const AC_TLGeo = {
  getRoleDescription,
  getPermissionDescription,
  getPermissions,
};
